import { stringifyFilterType } from "../ProcessTableFilters/utils";
import { GroupBy } from "@avenueops/shared-types";
import { DropdownSelect, Popover, PopoverTrigger, PopoverContent, Button } from "@avenueops/web-components";
import { RectangleGroupIcon } from "@heroicons/react/24/outline";
import { useProcessTableGroupBy } from "context/ProcessTableContext";

export function ProcessTableGroupingSelector() {
  const [groupBy, setGroupBy, clearGroupBy] = useProcessTableGroupBy();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="SECONDARY" LeadIcon={RectangleGroupIcon} size="MEDIUM">
          Group
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <div className="flex flex-col gap-3">
          <div className="font-medium text-sm whitespace-nowrap">Group By</div>
          <DropdownSelect
            name="groupBySelector"
            options={[
              { label: "None", value: "NO_GROUPING" },
              ...Object.values(GroupBy).map((option: GroupBy) => ({ label: stringifyFilterType(option), value: option })),
            ]}
            selectedValue={groupBy}
            onChange={(groupByOption) => {
              if (groupByOption && groupByOption !== "NO_GROUPING") {
                setGroupBy(groupByOption as GroupBy);
              } else {
                clearGroupBy();
              }
            }}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
